import { Badge, Card, Image, Popover, Rate } from "antd"
import { useNavigate } from "react-router-dom"
import { FAILBACK } from "src/constants/constants"
import { formatMoney } from "src/lib/utils"
import { linkYoutubeImg } from "src/lib/linkYoutube"
import { CourseItemStyle } from "./styled"
import { DetailService } from "src/pages/USER/Course/components/CourseItem"
const { Meta } = Card

const CourseItem = ({ item }) => {
  const navigate = useNavigate()
  return (
    <Popover
      placement="right"
      content={<DetailService item={item} />}
      title={null}
    >
      <CourseItemStyle xs={24} md={12} lg={8} xl={6}>
        <div className="d-flex-center ">
          <div style={{ width: "302px" }}>
            <Badge.Ribbon
              text={!!item?.Discount ? `-${item?.Discount}%` : null}
              showZero={false}
              color="#ff7a45"
              placement="end"
              className={!item?.Discount ? "hidden-ribbon" : ""}
            >
              <Card
                className="card-course"
                onClick={() => navigate(`/chi-tiet-khoa-hoc/${item?.CourseID}`)}
                style={{
                  width: 300,
                }}
                cover={
                  <Image
                    alt="khoa-hoc"
                    src={item?.Img || linkYoutubeImg(item?.VideoIntro)}
                    className="img-user"
                    fallback={FAILBACK}
                    preview={false}
                    style={{ height: 200, objectFit: "cover" }}
                  />
                }
                // actions={[
                //   <SettingOutlined key="setting" />,
                //   <EditOutlined key="edit" />,
                //   <EllipsisOutlined key="ellipsis" />,
                // ]}
              >
                <Meta
                  // avatar={
                  //   <Avatar src="https://xsgames.co/randomusers/avatar.php?g=pixel" />
                  // }
                  title={<div className="max-line2">{item?.CourseName}</div>}
                  description={
                    <div className="d-flex flex-column justify-content-space-between ">
                      <div className="d-flex justify-content-space-between">
                        <div className="teacher-name">
                          {item?.ListTeacherForCourse?.[0]?.TeacherName}
                        </div>
                        {!!item?.Discount && (
                          <div className="old-price">
                            {formatMoney(item?.CoursePrice)}
                            <sup>đ</sup>
                          </div>
                        )}
                      </div>
                      <div className="d-flex justify-content-space-between mt-12">
                        <div className="d-flex align-items-flex-end">
                          <Rate
                            disabled
                            allowHalf
                            defaultValue={item?.AverageEvaluate}
                            value={item?.AverageEvaluate}
                            style={{ fontSize: 14 }}
                          />
                          <div className="ml-6 fs-13">
                            ({item?.NumberEvaluate})
                          </div>
                        </div>
                        <div className="new-price">
                          {formatMoney(
                            item?.CoursePrice * ((100 - item?.Discount) / 100),
                          )}
                          <sup>đ</sup>
                        </div>
                      </div>
                    </div>
                  }
                />
              </Card>
            </Badge.Ribbon>
          </div>
        </div>
      </CourseItemStyle>
    </Popover>
  )
}

export default CourseItem
